let sample = null;
let sequence = 0;
const sessionId = () => `${performance.timeOrigin || 0}`;
export const CLOCK_DRIFT_THRESHOLD_MS = 120000;

export function recordServerClockSample(serverTime, sentAt, receivedAt = Date.now()) {
  const server = Date.parse(serverTime);
  const roundTripMs = receivedAt - sentAt;
  if (!Number.isFinite(server) || roundTripMs < 0 || roundTripMs > 2000) return null;
  sample = { offsetMs: server - (sentAt + roundTripMs / 2), roundTripMs,
    sampledAt: new Date(receivedAt).toISOString() };
  return sample;
}

export function captureClinicalTime({ clinicalTime = null, source = 'manual', timeZone } = {}) {
  const now = new Date();
  return {
    clinicalTime, source, deviceCapturedAt: now.toISOString(),
    timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    utcOffsetMinutes: -now.getTimezoneOffset(),
    sequence: ++sequence, sessionId: sessionId(), monotonicMs: performance.now(),
    clockSample: sample ? { ...sample } : null,
  };
}

export function clockReviewStatus(metadata) {
  const reading = metadata?.clockSample;
  if (!reading || reading.roundTripMs > 2000 || !Number.isFinite(reading.offsetMs)) return 'unverified';
  return Math.abs(reading.offsetMs) > CLOCK_DRIFT_THRESHOLD_MS ? 'review' : 'verified';
}
